export default stage => {
    const hostNameTemplate = 'secure.lni.wa.gov';
    let prefix = '';
    if (stage === 'integration') {
        prefix = 'dev-';
    } else if (stage === 'pre-production') {
        prefix = 'test-';
    }
    return `${prefix}${hostNameTemplate}`;
};